import { Images } from 'utils';

export const enumValues = {
    reqType: {
        Self: 'Self',
        All: 'All',
    },

    // FS_STATUS: ["Active", "Inactive"],
    STAFF_STATUS: ['Active', 'Inactive'],
    CLIENT_STATUS: ['Active', 'FBS', 'On Hold', 'Waitlist', 'Terminated', 'Graduated'],

    // enum types

    FUNDING_SOURCE_TYPES: [
        { label: 'Private Insurance', id: 'PRIVATE' },
        { label: 'Public Insurance', id: 'PUBLIC' },
        { label: 'School', id: 'SCHOOL' },
    ],

    FUNDING_MODIFIER_TYPES: ['Direct', 'Indirect'],

    FUNDING_MODIFIER_SERVICE_TYPES: [
        { title: 'Direct', id: 'DIRECT' },
        { title: 'Indirect', id: 'INDIRECT' },
    ],
    // PAYMENT_TYPES: ["Check", "Ach"],
    CREATE_PAYMENT_TYPES: ['Check', 'Ach', 'Cash'],
    // end

    // enum statuses
    CLIENT_STATUSES: ['Active', 'FBA', 'On Hold', 'Waitlist', 'Terminated', 'Graduated'],

    STATUSES: ['Active', 'Inactive', 'On Hold', 'Terminated'],
    BILLING_STATUSES: ['Open', 'Close'],
    BILLING_TRANSACTION_TYPES: ['Payer Paid', 'Client Resp', 'Client Paid', 'Partial Paid'],
    BILLING_CLAIM_STATUSES: ['Claimed', 'Not Claimed', 'Complete'],
    BILLING_INVOICE_STATUSES: ['Invoiced', 'Not Invoiced', 'Complete'],
    CLAIM_STATUSES: ['Pending', 'Closed', 'Submitted', 'Posted'],
    INVOICE_STATUSES: ['Pending', 'Closed', 'Submitted', 'Posted'],
    PAYMENT_STATUSES: ['Open', 'Closed', 'Voided'],
    // end

    // enums for Staff
    RESIDENCIES: ['US', 'citizen', 'pcitizen', 'work', 'visa'],

    GENDER_OPTIONS: [
        { label: 'Male', id: 'MALE' },
        { label: 'Female', id: 'FEMALE' },
        { label: 'Other', id: 'OTHER' },
    ],
    EMPLOYMENT_TYPES: ['Full-time', 'Part-time', 'Intern', 'Contractor'],
    // end

    // other enums
    PAYMENT_TYPES: ['Hourly', 'Salary'],
    TIME_TYPES: ['Daily', 'Weekly', 'Consecutive'],
    CREDENTIAL_TYPES: ['Degree', 'Clearance', 'License'],
    // end
};

export const RenderStatusEnum = (type) => {
    switch (type) {
        case 'Active':
            return 'ACTIVE';
        case 'Inactive':
            return 'INACTIVE';
        case 'FBA':
            return 'FBA';
        case 'On_Hold':
            return 'ON_HOLD';
        case 'Waitlist':
            return 'WAIT_LIST';
        case 'Terminated':
            return 'TERMINATED';
        case 'Graduated':
            return 'GRADUATED';

        default:
            return '';
    }
};

export const FLAGGED_VALUES = {
    INCOMPLETE_UNIT: 'INCOMPLETE_UNIT',
    REMOVED_FROM_CLAIM: 'REMOVED_FROM_CLAIM',
    UPDATE_FLAG: 'UPDATE_FLAG',
    NOT_INCOMPLETE_UNIT: 'NOT_INCOMPLETE_UNIT',
};
export const FLAGGED_ENUMS = [
    { id: 'All', label: 'All' },
    { id: FLAGGED_VALUES.INCOMPLETE_UNIT, label: 'Partial Units', img: Images.flag },
    { id: FLAGGED_VALUES.UPDATE_FLAG, label: 'Appt. Edit', img: Images.yellowFlag },
    { id: FLAGGED_VALUES.REMOVED_FROM_CLAIM, label: 'Prev. Claim', img: Images.blueFlag },
];

export const APPT_FLAGGED_ENUMS = [
    { id: 'All', label: 'All' },
    { id: FLAGGED_VALUES.INCOMPLETE_UNIT, label: 'Partial Units', img: Images.flag },
    { id: FLAGGED_VALUES.REMOVED_FROM_CLAIM, label: 'Prev. Claim', img: Images.blueFlag },
];

export const PAYROLL_FLAGGED_ENUMS = [
    { id: 'All', label: 'All' },
    { id: FLAGGED_VALUES.NOT_INCOMPLETE_UNIT, label: 'Not Partial' },
    { id: FLAGGED_VALUES.INCOMPLETE_UNIT, label: 'Partial Units', img: Images.yellowFlag },
];

export const FLAGGED = 'FLAGGED';
export const UNFLAGGED = 'UNFLAGGED';

export const APPT_ENUMS = {
    SERVICE: 'SERVICE',
    STAFF: 'STAFF',
    BREAK: 'BREAK',
    DRIVE: 'DRIVE',
    PAID: 'PAID',
    UNPAID: 'UNPAID',
    SICK_TIME: 'SICK_TIME',
};

export const agingEnums = {
    current: 'CURRENT',
    due: 'DUE',
    pastDue: 'PAST_DUE',
};

export const agingEnumsSelector = [
    { name: 'All', id: 'All' },
    { name: '0-30 days', id: agingEnums.current },
    { name: '31-60 days', id: agingEnums.due },
    { name: '61+ days', id: agingEnums.pastDue },
];

export const credentialTypesEnums = [
    { name: 'Degree', id: 'DEGREE' },
    { name: 'Clearances', id: 'CLEARANCES' },
    { name: 'License', id: 'LICENSE' },
];

export const activeInactiveEnums = [
    { name: 'Active', id: 'ACTIVE' },
    { name: 'Inactive', id: 'INACTIVE' },
];

export const timeSheetStatusesEnums = [
    { name: 'Active', id: 'ACTIVE' },
    { name: 'Processed', id: 'PROCESSED' },
];

export const tagEnums = {
    STAFF: 'Staff',
    CLIENT: 'Client',
    FUNDER: 'Funder',
    SERVICE: 'Service',
    CLAIM: 'Claim',
    INVOICE: 'Invoice',
    TIMESHEET: 'Timesheet',
    APPT: 'Appt',
    RESOURCE: 'Resource',
    GOAL: 'Goal',
    LIBRARY_GOAL: 'LibraryGoal',
    DOCUMENT: 'Document',

    TASK: 'Task',
};

export const staffStatusEnums = {
    ACTIVE: 'ACTIVE',
    INACTIVE: 'INACTIVE',
    HOLD: 'HOLD',
    ON_LEAVE: 'ON_LEAVE',
};

export const staffStatuses = [
    { label: 'Active', name: 'Active', id: staffStatusEnums.ACTIVE },
    { label: 'Inactive', name: 'Inactive', id: staffStatusEnums.INACTIVE, message: true },
    { label: 'On Hold', name: 'On Hold', id: staffStatusEnums.HOLD },
    { label: 'On Leave', name: 'On Leave', id: staffStatusEnums.ON_LEAVE },
];

export const clientStatusEnums = {
    ACTIVE: 'ACTIVE',
    INACTIVE: 'INACTIVE',
    FBA: 'FBA',
    ON_HOLD: 'ON_HOLD',
    WAIT_LIST: 'WAIT_LIST',
    TERMINATED: 'TERMINATED',
    GRADUATED: 'GRADUATED',
    INVITED: 'INVITED',
};

export const clientStatuses = [
    { label: 'Active', name: 'Active', id: clientStatusEnums.ACTIVE },
    { label: 'Inactive', name: 'Inactive', id: clientStatusEnums.INACTIVE },
    { label: 'FBA', name: 'FBA', id: clientStatusEnums.FBA },
    { label: 'On Hold', name: 'On Hold', id: clientStatusEnums.ON_HOLD },
    { label: 'Waitlist', name: 'Waitlist', id: clientStatusEnums.WAIT_LIST },
    { label: 'Terminated', name: 'Terminated', id: clientStatusEnums.TERMINATED },
    { label: 'Graduated', name: 'Graduated', id: clientStatusEnums.GRADUATED },
];

/** Authorization utilization timeline (Client → Authorization Utilization) */
export const authUtilizationStatusEnums = {
    ON_TARGET: 'ON_TARGET',
    OVER: 'OVER',
    UNDER: 'UNDER',
};

/**
 * A row's one Status-filter value — mirrors the API's AuthUtilizationFilterStatus (`service.filterStatus`).
 * Filter only; chip and bar colors still come from the pace status (`authUtilizationStatusEnums`).
 */
export const authUtilizationFilterStatusEnums = {
    ON_TARGET: 'ON_TARGET',
    OVER: 'OVER',
    UNDER: 'UNDER',
    AVAILABLE: 'AVAILABLE',
    SCHEDULED: 'SCHEDULED',
    CANCELLED: 'CANCELLED',
    EXPIRED: 'EXPIRED',
};

/** Status filter options. `values` are the filter statuses one checkbox sends — Cancelled and Expired share one, as in the legend. */
export const authUtilizationStatuses = [
    { label: 'On target', name: 'On target', id: authUtilizationFilterStatusEnums.ON_TARGET, values: [authUtilizationFilterStatusEnums.ON_TARGET] },
    { label: 'Overutilized', name: 'Overutilized', id: authUtilizationFilterStatusEnums.OVER, values: [authUtilizationFilterStatusEnums.OVER] },
    { label: 'Underutilized', name: 'Underutilized', id: authUtilizationFilterStatusEnums.UNDER, values: [authUtilizationFilterStatusEnums.UNDER] },
    { label: 'Available', name: 'Available', id: authUtilizationFilterStatusEnums.AVAILABLE, values: [authUtilizationFilterStatusEnums.AVAILABLE] },
    {
        label: 'Scheduled, not completed',
        name: 'Scheduled, not completed',
        id: authUtilizationFilterStatusEnums.SCHEDULED,
        values: [authUtilizationFilterStatusEnums.SCHEDULED],
    },
    {
        label: 'Cancelled / expired',
        name: 'Cancelled / expired',
        id: authUtilizationFilterStatusEnums.CANCELLED,
        values: [authUtilizationFilterStatusEnums.CANCELLED, authUtilizationFilterStatusEnums.EXPIRED],
    },
];

/** How an authorization's units are metered: per week, per month, or one pool for the whole term. */
export const authUtilizationPeriodEnums = {
    WEEK: 'WEEK',
    MONTH: 'MONTH',
    TERM: 'TERM',
};

/** Where a period sits relative to today. SCHEDULED utilization is projected from booked appointments. */
export const authUtilizationStateEnums = {
    COMPLETED: 'COMPLETED',
    CURRENT: 'CURRENT',
    SCHEDULED: 'SCHEDULED',
};

export const NO_PRIOR = 'No Prior Auth';

export const reqTypeEnums = {
    SELF: 'Self',
    ALL: 'All',
};

export const noteModels = {
    Client: 'Client',
    Staff: 'Staff',
    Funder: 'Funder',
    Claim: 'Claim',
    Timesheet: 'Timesheet',
    Invoice: 'Invoice',
    Appt: 'Appt',
    Assessment: 'Assessment',
    Goal: 'Goal',
};

/**
 * Resource types a comment thread can hang off. Values MUST match the backend
 * `CommentOnModel` enum (@therapylake/package/comment) — they are the `:onModel`
 * path segment for `/comment/:onModel/:resourceId`. Note payer === 'funder'.
 */
export const commentModels = {
    Claim: 'claim',
    Bill: 'bill',
    Funder: 'funder',
    Invoice: 'invoice',
    Appt: 'appt',
    Client: 'client',
    Staff: 'staff',
    Remittance: 'remittance',

    Txn: 'txn',
    InvoiceTxn: 'invoicetxn',
    PaymentTxn: 'paymentTransaction',

    /**
     * Organization Wishlist thread. NOT a backend `CommentOnModel`: the thread
     * lives in the master DB (shared with TherapyLake admins) and is served by
     * `/wishlist/:id/comments`. comment.service.js routes this value there.
     */
    Wishlist: 'wishlist',
};

export const claimStatusEnumsList = {
    PENDING: 'PENDING',
    OPEN: 'OPEN',
    PAID: 'PAID',
    APPEAL: 'APPEAL',
    CLOSED: 'CLOSED',
};
export const claimStatusEnumList = [
    { name: 'Pending', id: claimStatusEnumsList.PENDING },
    { name: 'Open', id: claimStatusEnumsList.OPEN },
    { name: 'Paid', id: claimStatusEnumsList.PAID },
    { name: 'Appeal', id: claimStatusEnumsList.APPEAL },
    { name: 'Closed', id: claimStatusEnumsList.CLOSED },
];

// Goal enums
export const goalDataTypeEnums = {
    PERCENT: 'PERCENT',
    RATING: 'RATING',
    FREQUENCY: 'FREQUENCY',
    WHOLE_INTERVAL: 'WHOLE_INTERVAL',
    PARTIAL_INTERVAL: 'PARTIAL_INTERVAL',
    DURATION: 'DURATION',
    LATENCY: 'LATENCY',
    SCORE: 'SCORE',
    MOMENTARY_TIME_SAMPLING: 'MOMENTARY_TIME_SAMPLING',
    RATE: 'RATE',
    IRT: 'IRT',
};

// Trial lifecycle — IN_PROGRESS rows are persisted on timer start so startTime
// survives crashes; transition to COMPLETED happens on stop with the final value.
export const trialStatusEnums = {
    IN_PROGRESS: 'IN_PROGRESS',
    COMPLETED: 'COMPLETED',
};

export const goalDataTypes = [
    { label: '% Correct', id: goalDataTypeEnums.PERCENT },
    { label: 'Frequency', id: goalDataTypeEnums.FREQUENCY },
    { label: 'Duration', id: goalDataTypeEnums.DURATION },
    { label: 'Latency', id: goalDataTypeEnums.LATENCY },
    { label: 'Rating', id: goalDataTypeEnums.RATING },
    { label: 'Whole Interval', id: goalDataTypeEnums.WHOLE_INTERVAL },
    { label: 'Partial Interval', id: goalDataTypeEnums.PARTIAL_INTERVAL },
    { label: 'Momentary Time Sampling', id: goalDataTypeEnums.MOMENTARY_TIME_SAMPLING },
    { label: 'Score', id: goalDataTypeEnums.SCORE },
    { label: 'Rate', id: goalDataTypeEnums.RATE },
    { label: 'IRT', id: goalDataTypeEnums.IRT },
];

export const renderGoalTypes = (type) => {
    switch (type) {
        case goalDataTypeEnums.PERCENT:
            return '% Correct';
        case goalDataTypeEnums.FREQUENCY:
            return 'Frequency';
        case goalDataTypeEnums.RATING:
            return 'Rating';
        case goalDataTypeEnums.DURATION:
            return 'Duration';
        case goalDataTypeEnums.LATENCY:
            return 'Latency';
        case goalDataTypeEnums.WHOLE_INTERVAL:
            return 'Whole Interval';
        case goalDataTypeEnums.PARTIAL_INTERVAL:
            return 'Partial Interval';
        case goalDataTypeEnums.SCORE:
            return 'Score';
        case goalDataTypeEnums.MOMENTARY_TIME_SAMPLING:
            return 'Momentary Time Sampling';
        case goalDataTypeEnums.RATE:
            return 'Rate';
        case goalDataTypeEnums.IRT:
            return 'IRT';
        default:
            return type;
    }
};

export const apptEnums = {
    PENDING: 'PENDING',
    COMPLETED: 'COMPLETED',
    CANCELLED: 'CANCELLED',
};

export const orgIntegrationEnums = {
    VOICE_NOTE: 'VOICE_NOTE',
    C_SESSION: 'C_SESSION',
    AI_BRIDGE: 'AI_BRIDGE',
};

export const sessionStatusEnums = {
    IN_PROGRESS: 'IN_PROGRESS',
    PAUSED: 'PAUSED',
    COMPLETED: 'COMPLETED',
};

export const renderIntervalText = (type) => {
    switch (type) {
        case goalDataTypeEnums.WHOLE_INTERVAL:
            return 'Did behavior happen during the entire interval?';
        case goalDataTypeEnums.PARTIAL_INTERVAL:
            return 'Did behavior happen at least once during the interval?';
        case goalDataTypeEnums.MOMENTARY_TIME_SAMPLING:
            return 'Is the behavior happening now?';

        default:
            return type;
    }
};

export const evalModeEnums = {
    BY_DAY: 'BY_DAY',
    BY_SESSION: 'BY_SESSION',
};

/**
 * How the evaluation window is judged.
 * CONSECUTIVE — every session/day in the window must meet the criteria (the original behaviour).
 * TOTAL       — the window's average must meet the criteria.
 * Goals saved before this selector existed come back without the field; the backend reads that
 * as CONSECUTIVE, so the selects below fall back to the same value.
 */
export const masteryEvalTypeEnums = {
    CONSECUTIVE: 'CONSECUTIVE',
    TOTAL: 'TOTAL',
};

export const masteryEvalTypeList = [
    { value: masteryEvalTypeEnums.CONSECUTIVE, label: 'Consecutive' },
    { value: masteryEvalTypeEnums.TOTAL, label: 'Total' },
];

/**
 * PERCENT goals only: mastery / baseline / maintenance can judge each session by its first trial.
 * A session counts when that first trial is the selected response (correct = 1, incorrect = 0).
 */
export const firstTrialResponseEnums = {
    CORRECT: 'CORRECT',
    INCORRECT: 'INCORRECT',
};

export const firstTrialResponseList = [
    { value: firstTrialResponseEnums.CORRECT, label: 'Correct' },
    { value: firstTrialResponseEnums.INCORRECT, label: 'Incorrect' },
];

/**
 * DURATION goals only: how a session's trials resolve to the value a mastery / baseline / maintenance rule compares.
 * TOTAL (default) sums the durations, AVERAGE takes their mean.
 */
export const durationCalcEnums = {
    TOTAL: 'TOTAL',
    AVERAGE: 'AVERAGE',
};

export const durationCalcList = [
    { value: durationCalcEnums.TOTAL, label: 'Total' },
    { value: durationCalcEnums.AVERAGE, label: 'Average' },
];

/**
 * How Clinical Insights target charts plot a session (mirrors GraphValueMode in the API).
 * DEFAULT is the regular value; AVERAGE is DURATION-only (mean trial duration); FIRST_TRIAL is PERCENT-only
 * (100 when the first trial is correct, else 0 — a grouped bucket reads as % of sessions with a correct first response).
 */
export const graphValueModeEnums = {
    DEFAULT: 'DEFAULT',
    AVERAGE: 'AVERAGE',
    FIRST_TRIAL: 'FIRST_TRIAL',
};

export const onModelFolderEnum = {
    TARGET: 'Target',
    OPTION: 'Option',
};

export const masteryDirectionEnums = {
    ABOVE: 'ABOVE',
    BELOW: 'BELOW',
    EQUAL: 'EQUAL',
};

export const masteryDirectionList = [
    { value: masteryDirectionEnums.ABOVE, label: 'Above' },
    { value: masteryDirectionEnums.BELOW, label: 'Below' },
    { value: masteryDirectionEnums.EQUAL, label: 'Equal' },
];

export const targetStatusEnums = {
    PENDING: 'PENDING',
    BASELINE: 'BASELINE',
    TEACHING: 'TEACHING',
    MASTERED: 'MASTERED',
    DISCONTINUED: 'DISCONTINUED',
    HOLD: 'HOLD',
    /** */
    MAINTENANCE: 'MAINTENANCE',
    COMPLETED: 'COMPLETED',
    // GENERALIZATION = 'GENERALIZATION',
};

export const renderTargetStatuses = [
    {
        label: 'Pending',
        id: targetStatusEnums.PENDING,
        value: targetStatusEnums.PENDING,
        color: '#B54708',
        circleColor: '#B54708',
        textColor: '#B54708',
        backgroundColor: '#FFFAEB',
        filter: 'brightness(0) saturate(100%) invert(25%) sepia(96%) saturate(1813%) hue-rotate(20deg) brightness(95%) contrast(107%)'
    },
    {
        label: 'Baseline',
        id: targetStatusEnums.BASELINE,
        value: targetStatusEnums.BASELINE,
        color: '#5925DC',
        circleColor: '#5925DC',
        textColor: '#5925DC',
        backgroundColor: '#F4F3FF',
        filter: 'brightness(0) saturate(100%) invert(12%) sepia(81%) saturate(6534%) hue-rotate(260deg) brightness(89%) contrast(94%)',
    },
    {
        label: 'Teaching',
        id: targetStatusEnums.TEACHING,
        value: targetStatusEnums.TEACHING,
        color: '#175CD3',
        circleColor: '#175CD3',
        textColor: '#175CD3',
        backgroundColor: '#EFF8FF',
        filter: 'brightness(0) saturate(100%) invert(23%) sepia(98%) saturate(1561%) hue-rotate(204deg) brightness(104%) contrast(96%)',
    },
    {
        label: 'Mastered',
        id: targetStatusEnums.MASTERED,
        value: targetStatusEnums.MASTERED,
        color: '#027A48',
        circleColor: '#027A48',
        textColor: '#027A48',
        backgroundColor: '#ECFDF3',
        filter: 'brightness(0) saturate(100%) invert(25%) sepia(70%) saturate(2318%) hue-rotate(141deg) brightness(89%) contrast(98%)',
    },
    {
        label: 'Discontinued',
        id: targetStatusEnums.DISCONTINUED,
        value: targetStatusEnums.DISCONTINUED,
        color: '#C01048',
        circleColor: '#C01048',
        textColor: '#C01048',
        backgroundColor: '#FFF1F3',
        filter: 'brightness(0) saturate(100%) invert(17%) sepia(66%) saturate(4340%) hue-rotate(328deg) brightness(83%) contrast(101%)',
    },
    {
        label: 'Hold',
        id: targetStatusEnums.HOLD,
        value: targetStatusEnums.HOLD,
        color: '#344054',
        circleColor: '#344054',
        textColor: '#344054',
        backgroundColor: '#F2F4F7',
        filter: 'brightness(0) saturate(100%) invert(23%) sepia(37%) saturate(412%) hue-rotate(178deg) brightness(91%) contrast(93%)',
    },

    {
        label: 'Maintenance',
        id: targetStatusEnums.MAINTENANCE,
        value: targetStatusEnums.MAINTENANCE,
        color: '#C4320A',
        circleColor: '#FB6514',
        textColor: '#C4320A',
        backgroundColor: '#FFF6ED',
        filter: 'brightness(0) saturate(100%) invert(22%) sepia(77%) saturate(2225%) hue-rotate(356deg) brightness(97%) contrast(98%)',
    },
    {
        label: 'Completed',
        id: targetStatusEnums.COMPLETED,
        value: targetStatusEnums.COMPLETED,
        color: '#5925DC',
        circleColor: '#5925DC',
        textColor: '#5925DC',
        backgroundColor: '#F4F3FF',
        filter: 'brightness(0) saturate(100%) invert(22%) sepia(90%) saturate(6812%) hue-rotate(258deg) brightness(87%) contrast(98%)',
    },
    // {
    //     label: 'Generalization',
    //     id: targetStatusEnums.GENERALIZATION,
    //     value: targetStatusEnums.GENERALIZATION,
    //     color: '#05603A',
    //     circleColor: '#05603A',
    //     textColor: '#05603A',
    //     backgroundColor: '#F0FDF4',
    // },
];

export const videoModelEnums = {
    GOAL_INSTRUCTION: 'GOAL_INSTRUCTION',
};

export const claimEnums = {
    PENDING: 'PENDING',
    OPEN: 'OPEN',
    CLOSED: 'CLOSED',
    APPEAL: 'APPEAL',
    COMPLETED: 'COMPLETED',
    COMPLETE: 'COMPLETE',
    PAID: 'PAID',
    SUBMITTED: 'SUBMITTED',
};

export const goalPerRateEnumList = [
    { label: 'Second', id: 'SECOND' },
    { label: 'Minute', id: 'MINUTE' },
    { label: 'Hour', id: 'HOUR' },
];

export const globalSessionENums = {
    SESSION_EXPIRED: 'SESSION_EXPIRED',
    VOICE_NOTE_DELETE: 'VOICE_NOTE_DELETE',
    VOICE_NOTE_UPDATED: 'VOICE_NOTE_UPDATED',
    REPORT_GENERATION: 'REPORT_GENERATION',
    PROGRESS_REPORT_PDF: 'PROGRESS_REPORT_PDF',
    PROFILE_UPDATED: 'PROFILE_UPDATED',
};

export const attributeTypes = {
    RICH_TEXT: 'RICH_TEXT',
    INPUT: 'INPUT',
    SELECT: 'SELECT',
    CHECK_BOX: 'CHECK_BOX',
    RADIO_BUTTON: 'RADIO_BUTTON',
    // DATE: 'DATE',
    TABLE: 'TABLE',
    SESSION_DATA_TABLE: 'SESSION_DATA_TABLE',
    SIGNATURE: 'SIGNATURE',
    UPLOAD: 'UPLOAD',
    GOAL: 'GOAL',
    ABC_DATA: 'ABC_DATA',

    GRAPH: 'GRAPH',
    TARGET: 'TARGET',
};

export const fileEnums = {
    REMITTANCE: 'REMITTANCE',
    PAYER: 'PAYER',
    STAFF: 'STAFF',
    PAYROLL_TIMESHEET: 'PAYROLL_TIMESHEET',
    RESOURCE: 'RESOURCE',
    APPT: 'APPT',
    CLIENT: 'CLIENT',
    CLAIM: 'CLAIM',
    INVOICE: 'INVOICE',
    GOAL: 'GOAL',
};

export const userTypeEnums = {
    STAFF: 'STAFF',
    CLIENT: 'CLIENT',
};

export const scheduleViewEnum = {
    LIST: 'LIST',
    CALENDAR: 'CALENDAR',
};

export const noteStatusEnums = {
    DRAFT: 'DRAFT',
    COMPLETED: 'COMPLETED',
    IN_REVIEW: 'IN_REVIEW',
    UPDATE_REQUEST: 'UPDATE_REQUEST',
};